<template>
  <div>
   <div class="fixed z-50 inset-0 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
    <div class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>
​
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
​
      <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle max-w-md w-full">
        <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
          <div class="sm:flex sm:items-start">
            <div class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
              <svg class="h-6 w-6 text-red-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
              </svg>
            </div>
            <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
              <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-title">
               Reject
              </h3>
              <div class="mt-2">
                <p class="text-sm sm:text-base text-gray-500">
                  Reason ?
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-2">
            <div id="tabs-1-panel-1" class="p-4 -m-0.5 rounded-lg" aria-labelledby="tabs-1-tab-1" role="tabpanel" tabindex="0">
                <label for="comment" class="sr-only">Comment</label>
                <div>
                <textarea maxlength="500" v-model="comment" rows="5" name="comment" id="comment" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" placeholder="Add your comment..."></textarea>
                </div>
            </div>
        </div>
        <div class="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse">
          <button @click="saveEvidenceStatus()"  type="button" class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto text-sm">
            Submit
          </button>
          <button v-if="isModal" @click="closeModal()" type="button" class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 sm:mt-0 sm:ml-3 sm:w-auto text-sm">
              Close
          </button>
          <button v-else @click="closeRejectModal()"  type="button" class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 sm:mt-0 sm:ml-3 sm:w-auto text-sm">
            Cancel
          </button>
        </div>
      </div>
    </div>
</div> 
</div>
</template>

<script>
import { siteUrl } from '../../config/base';
import ProtestRequestApi from "../../services/api/AdminProtestRequest";
export default {
props :["protest_request_uid","is-modal"],
  components: {

  },
  data() {
    return {
        comment:'',
    };
  },
  methods: {
      closeRejectModal(){
          this.$emit('close-reject-modal',{'status_changed':null});
      },
      closeModal(){
            window.closeModal();
      },

      saveEvidenceStatus(){
        if(this.comment == '') {
          this.$toast.open('Please fill the reason');
          return;
        }

        if(this.comment.length > 500) {
          this.$toast.open('Maximum character allowed in comment is 500');
          return;
        }

        ProtestRequestApi.changeEvidenceStatus(
          this.protest_request_uid,
          this.comment,
          3
        ).then((res) => {
          this.$toast.open('Status Updated');
          this.$emit('close-reject-modal',{'status_changed':3,'comment':this.comment});
          window.flash('Status updated',"success");
          window.closeModal();
          // setTimeout(() => window.location.href = siteUrl + "/operator/evidence-uploads", 2000);
        }).catch(function(error) {
          throw new Error(error);
        });
           
      }
      
  }
};
</script>

<style scoped>
</style>
